<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M6.392 6.057a.342.342 0 00-.342.344v12.534a.342.342 0 00.342.341h19.216a.342.342 0 00.342-.343v-8.419a.342.342 0 00-.342-.343h-9.196a2.39 2.39 0 01-2.085-1.223l-1.523-2.716a.342.342 0 00-.298-.175H6.392zM4 6.41A2.396 2.396 0 016.392 4h6.114a2.39 2.39 0 012.085 1.223l1.523 2.717c.06.107.174.174.298.174h9.196a2.396 2.396 0 012.392 2.4v8.42c0 1.325-1.071 2.4-2.392 2.4H17v1.827a3.175 3.175 0 012.006 2.006H27a1 1 0 110 2h-7.994a3.168 3.168 0 01-6.011 0H5a1 1 0 110-2h7.995A3.175 3.175 0 0115 23.16v-1.828H6.466c-1.317 0-2.46-1.076-2.466-2.398V6.409zm13.167 19.758a1.167 1.167 0 11-2.334 0 1.167 1.167 0 012.334 0z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'serverFtpOutline'
}
</script>
